import { render, staticRenderFns } from "./AddComm.vue?vue&type=template&id=545dadad&"
import script from "./AddComm.vue?vue&type=script&lang=js&"
export * from "./AddComm.vue?vue&type=script&lang=js&"
import style0 from "./AddComm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports